import { ReactElement, ReactNode, useEffect, useState } from 'react';

import { SubsidiaryBridge } from '@kakaopay-web-ui/template';

import { useQueryString } from '~/hooks/useQueryString';

type Props = {
  children: ReactNode;
};

const BRIDGE_SHOW_TIME = 500;

const WithShowSecBridge = ({ children }: Props) => {
  const { isSkipSecBridge = true } = useQueryString<{
    isSkipSecBridge?: boolean;
  }>({
    convertToCamelcase: true,
  });

  const [isShow, setIsShow] = useState<boolean>(!isSkipSecBridge);

  useEffect(() => {
    setTimeout(() => setIsShow(false), BRIDGE_SHOW_TIME);
  }, []);

  return isShow ? (
    <SubsidiaryBridge companyType="stock" isFixed={true} />
  ) : (
    (children as ReactElement)
  );
};

export default WithShowSecBridge;
